export default "__VITE_ASSET___lHmTxN9__"